import React from 'react';
import { Link, graphql, StaticQuery } from "gatsby";

const linkStyle = 'f6 link white-80';
const today = new Date();

export default function FooterWithData(props) {
  return (
    <StaticQuery
      query={graphql`
        query {
          site {
            siteMetadata {
              loginLink
            }
          }
        }
      `}
      render={data => <Footer data={data} {...props} />}
    />
  )
}

const Footer = ({ data }) => (
  <footer
    className="mt2 pa4 white bt bw2"
    style={{ backgroundColor: '#32a6b4', borderColor: '#0f4750' }}
  >
    <div className="mw7 center">
      <div className="fl w-20 dn dib-ns">
        <Link to="/">
          <img src="/img/logo-square-white.png" alt="O3" className="mw-100" />
        </Link>
      </div>

      <div className="fl w-20-ns mh5-ns fw3 pl2-l">
        <span className="f6 ttu fw5 mb1 dib tracked">Navigate</span>
        <ul className="list pl0">
          <li className="mb1">
            <Link to="/outreach/features/" className={linkStyle}>
              Features
            </Link>
          </li>
          <li className="mb1">
            <Link to="/outreach/pricing/" className={linkStyle}>
              Pricing
            </Link>
          </li>
          <li className="mb1">
            <Link to="/blog/" className={linkStyle}>
              Blog
            </Link>
          </li>
          <li className="mb1">
            <Link to="/contact/" className={linkStyle}>
              Contact Us
            </Link>
          </li>
          <li className="mb1">
            <a href={data.site.siteMetadata.loginLink} className={linkStyle}>
              Log In
            </a>
          </li>
        </ul>
      </div>

      <div className="fl w-40-ns pt2 pt0-ns">
        <span className="f6 ttu fw5 mb1 dib tracked">About Us</span>
        <p className="f6 lh-copy white-80">
          O3 helps businesses tap into what their customers really think and give a voice to
          customers that they&apos;ve never had before, re-establishing those one-on-one
          relationships.
        </p>
        <p className="f6 lh-copy white-80">
          We believe that the key to better business is better, truly human relationships and that
          when used correctly technology can help.
        </p>
      </div>

      <div className="cl pt3">
        <p className="tc f6 fw1">
          © {today.getFullYear()} - SMS Reviews (O3 Powered), a Blue Star Services, LLC Company |{' '}
          <Link to="/privacy-policy/" className={linkStyle}>
            Privacy Policy
          </Link>{' '}
          |{' '}
          <Link to="/terms-of-service/" className={linkStyle}>
            Terms of Service
          </Link>
        </p>
        <p className="tc f6 fw1">
          Net Promoter, Net Promoter Score and NPS are registered trademarks of Bain & Company,
          Inc., Satmetrix Systems, Inc., and Fred Reichheld.
        </p>
      </div>
    </div>
  </footer>
);
